import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Observable, BehaviorSubject, combineLatest, of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CsvService } from '../csv.service';
import { PhotoDialogComponent } from './photo-dialog.component';
import { ImageErrorDirective } from 'src/app/_directives/ui-image-error.directive';

interface CsvData {
  columns: string[];
  rows: Record<string, string>[];
}

@Component({
  selector: 'app-photo-book',
  templateUrl: './photo-book.component.html',
  styleUrls: ['./photo-book.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    ImageErrorDirective
  ]
})
export class PhotoBookComponent implements OnChanges {
  @Input() csvUrl!: string;
  @Input() imageColumn!: string;
  @Input() title!: string;
  @Input() subTitle!: string;
  @Input() email!: string;
  @Input() observacion!: string;

  private searchTerm$ = new BehaviorSubject<string>('');

  @Input() set searchTerm(value: string) {
    this.searchTerm$.next(value?.toLowerCase() ?? '');
  }

  data$!: Observable<CsvData>;
  columns$!: Observable<string[]>;
  rows$!: Observable<any[]>;

  constructor(
    private csvService: CsvService,
    public dialog: MatDialog
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['csvUrl'] && this.csvUrl) {
      this.data$ = this.csvService.getCsvData(this.csvUrl);
      this.columns$ = this.data$.pipe(map(data => data.columns));

      this.rows$ = combineLatest([
        this.data$.pipe(map(data => data.rows)),
        this.searchTerm$.pipe(startWith(''))
      ]).pipe(
        map(([rows, term]) => {
          if (!term.trim()) return rows;

          return rows.filter(row =>
            Object.values(row).some(value =>
              (value ?? '').toLowerCase().includes(term)
            )
          );
        })
      );
    }
  }

  openDialog(item: any): void {
    this.dialog.open(PhotoDialogComponent, {
      width: '90vw',
      maxWidth: '800px',
      minWidth: '300px',
      data: {
        item,
        imageColumn: this.imageColumn,
        title: this.title,
        subTitle: this.subTitle,
        email: this.email,
        observacion: this.observacion,
        columnas$: this.columns$,
      }
    });
  }

  isImageColumn(col: string): boolean {
    return col === this.imageColumn;
  }

  identify(index: number, item: any) {
    return item.id ? item.id : index;
  }
}
